import React from 'react'
import "./ProductDetail92.css"
function ProductDetail92() {
  return (
    <>
    <div className='container-fluid backcolo1 py-3 pe-5 '>
    
        <div className='row pe-0 '>
            <div className='col-12 col-md-6 col-sm-6 p-5'>
                <div className='paddi'>
                <h1 className='headi text-light'>Toll Plaza<span className='moni'> Monitoring System</span></h1>
            <p className='partext text-light'>TPMS (Toll Plaza Monitoring System) is an advanced AI-driven solution 
designed to revolutionize toll plaza operations. From real-time vehicle 
tracking to intelligent analytics and fraud detection, TPMS ensures 
accuracy, efficiency, and complete operational control across all toll lanes. 
</p>

<div className='d-flex align-items-center justify-content-start gap-4'>
    <button className=' butt border-0'>Get Live Demo</button>
    <button className=' butt border-0'>Talk To Expert</button>
</div>
</div>
            </div>
            <div className='col-12 col-md-6 col-sm-6 p-5 backcolo'
            
            >
                <div className='img-wrapper'>
                <img
                src='ImagesNew/dashboard-LR-1.jpeg'
                alt='tpms_img'
                className='img92'
                />
                </div>
            </div>

        </div>
   
    </div>
    </>
  )
}

export default ProductDetail92
